import React, { useState } from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { GRADIENTS } from '../../../config/designSystem/Colors';
import { GradientSlider } from './GradientSlider';

const meta = {
  title: 'Diary/GradientSlider',
  component: GradientSlider,
  args: {
    value: 2,
    steps: 5,
    onChange: () => undefined,
    gradient: GRADIENTS.modules.LAVENDER.base,
  },
  decorators: [
    Story => (
      <View style={{ width: 320 }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof GradientSlider>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Middle: Story = {};

const InteractiveGradientSlider = (args: React.ComponentProps<typeof GradientSlider>) => {
  const [value, setValue] = useState(args.value);
  return (
    <View style={{ width: 320 }}>
      <GradientSlider {...args} value={value} onChange={setValue} />
    </View>
  );
};

export const Interactive: Story = {
  render: args => <InteractiveGradientSlider {...args} />,
};
